/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { MouseEventHandler } from "react";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import { HashLink as Link } from "react-router-hash-link";
import doubleButtonStyle from "./doubleButtonStyle";

type DoubleButtonProps = {
  backClick?: MouseEventHandler;
  backLink: string;
  backText?: string;
  buttonClick?: MouseEventHandler;
  buttonLink: string | object;
  buttonText?: string;
  hideBackButton?: boolean;
};

const DoubleButton = ({
  backClick,
  backLink,
  backText = "zurück",
  buttonClick,
  buttonLink,
  buttonText = "weiter",
  hideBackButton = false,
}: DoubleButtonProps) => {
  const backButton = () => {
    return (
      !hideBackButton && (
        <Button sx={doubleButtonStyle.backButton} fullWidth variant={"text"} onClick={backClick} component={Link} to={backLink}>
          {backText}
        </Button>
      )
    );
  };

  return (
    <Grid container justifyContent={"center"} alignItems={"baseline"} sx={doubleButtonStyle.buttonActions}>
      <Grid item xs={12} sm={6} sx={doubleButtonStyle.buttonContainer}>
        {backButton()}
      </Grid>
      <Grid item xs={12} sm={6} sx={doubleButtonStyle.buttonContainer} >
        <Button fullWidth color="primary" variant="contained" onClick={buttonClick} component={Link} to={buttonLink}>
          {buttonText}
        </Button>
      </Grid>
    </Grid>
  );
};

export default DoubleButton;
